import { Box } from '@mui/material'

import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import LightBulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import OpenWithIcon from '@mui/icons-material/OpenWith'

import { t } from 'i18next'

import { Item } from '@pages/LandingPage/components/Item'

import { containerSx, contentSx, itemSx } from './styles'

const Section1 = () => (
  <Box data-testid="tech-vendors-features-section-1" sx={containerSx}>
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" sx={contentSx}>
      <Box gridColumn={itemSx}>
        <Item
          variant="white"
          title={t('Modernized Matchmaking vs. Outdated Lead Generation')}
          subtitle={t(
            'Break free from outdated demand generation methods. Our matchmaking marketplace provides a more efficient and precise approach, connecting you with Tech Customers whose needs align with your offerings.'
          )}
          icon={LightBulbOutlinedIcon}
        />
      </Box>
      <Box gridColumn={itemSx}>
        <Item
          variant="white"
          title={t('Receive Actionable Leads')}
          subtitle={t(
            'Receive leads from Tech Customers who have reviewed your information and clicked "Accept Match." These leads are driven by customer interest, making them inherently more closable and valuable.'
          )}
          icon={AssignmentIndIcon}
        />
      </Box>
      <Box gridColumn={itemSx}>
        <Item
          variant="white"
          title={t('Authentic & Meaningful Connections')}
          subtitle={t(
            'By shifting the power to Tech Customers and prioritizing their needs, our B2B marketplace creates a more valuable and meaningful connection between Tech Customers and technology vendors. This leads to stronger partnerships, increased satisfaction, and improved sales conversions.'
          )}
          icon={OpenWithIcon}
        />
      </Box>
      <Box gridColumn={itemSx}>
        <Item
          variant="white"
          title={t('Affordable Flat Rate Subscription')}
          subtitle={t(
            'Move away from costly lead generation that deliver abysmal results. Our platform offers an affordable, flat-rate subscription at a fraction of the cost and delivers superior ROI compared to outdated pay-per-lead models.'
          )}
          icon={AddShoppingCartIcon}
        />
      </Box>
    </Box>
  </Box>
)

export { Section1 }
